import { useQuery } from '@tanstack/react-query';

// models
import { LabelModel } from '../../models/label.model';

// constants
import API from '../../services/api';

// hooks
import labelKeys from './_queryKeys';

const getLabels = async (componentTypeId: string): Promise<LabelModel[]> => {
    const { data } = await API.getLabelsV1(componentTypeId);

    return data;
};

export default function useLabelsQuery(componentTypeId: string) {
    return useQuery({
        queryKey: labelKeys.labelsByComponentId(componentTypeId),
        queryFn: () => getLabels(componentTypeId),
        enabled: !!componentTypeId,
    });
}
